import MetricsLineChart from "./MetricsLineChart";
import { combineMetricsForChart, MetricTimeseries } from "./helpers";
import { camelCaseToTitleCase, CHART_COLORS } from "./formatters";

interface MultiMetricChartProps {
    metrics: MetricTimeseries[];
    categoryHint: string;
    height?: number;
}

export default function MultiMetricChart({
    metrics,
    categoryHint,
    height = 300,
}: MultiMetricChartProps) {
    const { data, keys } = combineMetricsForChart(metrics);

    const lines = keys.map((key, index) => ({
        dataKey: key,
        name: camelCaseToTitleCase(key),
        color: CHART_COLORS[index % CHART_COLORS.length],
    }));

    return (
        <MetricsLineChart
            data={data}
            lines={lines}
            height={height}
            categoryHint={categoryHint}
            showLegend
        />
    );
}
